import traversy from "../../../assets/img/youtube/english/traversy.webp";
import codestackr from "../../../assets/img/youtube/english/codestackr.webp";
import deved from "../../../assets/img/youtube/english/deved.webp";
import academind from "../../../assets/img/youtube/english/academind.webp";
import benawad from "../../../assets/img/youtube/english/benawad.webp";
import techz from "../../../assets/img/youtube/english/techz.webp";
import amigoscode from "../../../assets/img/youtube/english/amigoscode.webp";
import briandesign from "../../../assets/img/youtube/english/briandesign.webp";
import chrishawkes from "../../../assets/img/youtube/english/chrishawkes.webp";
import coderone from "../../../assets/img/youtube/english/coderone.webp";
import codevolution from "../../../assets/img/youtube/english/codevolution.webp";
import codingaddict from "../../../assets/img/youtube/english/codingaddict.webp";
import darkcode from "../../../assets/img/youtube/english/darkcode.webp";
import easytutorials from "../../../assets/img/youtube/english/easytutorials.webp";
import freecodecamp from "../../../assets/img/youtube/english/freecodecamp.webp";
import jsmastery from "../../../assets/img/youtube/english/jsmastery.webp";
import leveluptuts from "../../../assets/img/youtube/english/leveluptuts.webp";
import raddythebrand from "../../../assets/img/youtube/english/raddythebrand.webp";
import maksim from "../../../assets/img/youtube/english/maksim.webp";
import redstapler from "../../../assets/img/youtube/english/redstapler.webp";
import skillthrive from "../../../assets/img/youtube/english/skillthrive.webp";
import stefan from "../../../assets/img/youtube/english/stefan.webp";
import vicodemedia from "../../../assets/img/youtube/english/vicodemedia.webp";
import webdev from "../../../assets/img/youtube/english/webdev.webp";
import mosh from "../../../assets/img/youtube/english/mosh.webp";
import csdojo from "../../../assets/img/youtube/english/csdojo.webp";
import ester from "../../../assets/img/youtube/english/ester.webp";
import devon from "../../../assets/img/youtube/english/devon.webp";

export const DataEnglish = [
  {
    icon: traversy,
    cName: "icon",
    title: "Traversy Media",
    path: "https://www.youtube.com/c/TraversyMedia/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: codestackr,
    cName: "icon",
    title: "codeSTACKr",
    path: "https://www.youtube.com/c/codeSTACKr/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: deved,
    cName: "icon",
    title: "Dev Ed",
    path: "https://www.youtube.com/c/DevEd/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: academind,
    cName: "icon",
    title: "Academind",
    path: "https://www.youtube.com/c/Academind/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: benawad,
    cName: "icon",
    title: "Ben Awad",
    path: "https://www.youtube.com/c/BenAwad97/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: techz,
    cName: "icon",
    title: "TechZ",
    path: "https://www.youtube.com/channel/UC2S7KicQMgJaVY1Kjw1druQ/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: amigoscode,
    cName: "icon",
    title: "Amigoscode",
    path: "https://www.youtube.com/c/amigoscode/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: briandesign,
    cName: "icon",
    title: "Brian Design",
    path: "https://www.youtube.com/channel/UCsKsymTY_4BYR-wytLjex7A/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: chrishawkes,
    cName: "icon",
    title: "Chris Hawkes",
    path: "https://www.youtube.com/c/noobtoprofessional/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: coderone,
    cName: "icon",
    title: "CoderOne",
    path: "https://www.youtube.com/c/CoderOne/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: codevolution,
    cName: "icon",
    title: "Codevolution",
    path: "https://www.youtube.com/c/Codevolution/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: codingaddict,
    cName: "icon",
    title: "Coding Addict",
    path: "https://www.youtube.com/c/CodingAddict/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: darkcode,
    cName: "icon",
    title: "DarkCode",
    path: "https://www.youtube.com/c/DarkCodeOnline/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: easytutorials,
    cName: "icon",
    title: "Easy Tutorials",
    path: "https://www.youtube.com/c/EasyTutorialsVideo/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: freecodecamp,
    cName: "icon",
    title: "FreeCodeCamp",
    path: "https://www.youtube.com/c/Freecodecamp/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: jsmastery,
    cName: "icon",
    title: "JavaScript Mastery",
    path: "https://www.youtube.com/c/JavaScriptMastery/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: leveluptuts,
    cName: "icon",
    title: "LevelUpTuts",
    path: "https://www.youtube.com/c/LevelUpTuts/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: raddythebrand,
    cName: "icon",
    title: "RaddyTheBrand",
    path: "https://www.youtube.com/c/RaddyTheBrand/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: maksim,
    cName: "icon",
    title: "Maksim Ivanov",
    path: "https://www.youtube.com/c/satansdeer1/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: redstapler,
    cName: "icon",
    title: "Red Stapler",
    path: "https://www.youtube.com/c/RedStapler_channel/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: skillthrive,
    cName: "icon",
    title: "Skillthrive",
    path: "https://www.youtube.com/c/Skillthrive/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: stefan,
    cName: "icon",
    title: "Stefan Mischook",
    path: "https://www.youtube.com/c/StefanMischook/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: vicodemedia,
    cName: "icon",
    title: "Vicode Media",
    path: "https://www.youtube.com/c/VicodeMedia/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: webdev,
    cName: "icon",
    title: "Web Dev Simplified",
    path: "https://www.youtube.com/c/WebDevSimplified/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: mosh,
    cName: "icon",
    title: "Programming with Mosh",
    path: "https://www.youtube.com/user/programmingwithmosh",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: csdojo,
    cName: "icon",
    title: "CS Dojo",
    path: "https://www.youtube.com/c/CSDojo/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: ester,
    cName: "icon",
    title: "Esterling Accime",
    path: "https://www.youtube.com/c/EsterlingAccime/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: devon,
    cName: "icon",
    title: "Devon Crawford ",
    path: "https://www.youtube.com/c/DevonCrawford/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
];
